export default __webpack_public_path__ + "static/media/ic_gmx_40_.8cd483b1.svg";